import { render, staticRenderFns } from "./ComingsoonPage.vue?vue&type=template&id=1ba7512d&scoped=true&"
import script from "./ComingsoonPage.vue?vue&type=script&lang=js&"
export * from "./ComingsoonPage.vue?vue&type=script&lang=js&"
import style0 from "./ComingsoonPage.vue?vue&type=style&index=0&id=1ba7512d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7512d",
  null
  
)

export default component.exports